module.exports = __webpack_public_path__ + "files/8db1bbc5cfc2bb61670bf02a2826e575.png";